import { render, staticRenderFns } from "./AppTopWarning.vue?vue&type=template&id=34cf1640"
import script from "./AppTopWarning.vue?vue&type=script&lang=ts"
export * from "./AppTopWarning.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports